import config from '../config/config';

interface PixelEventParams {
  content_name?: string;
  content_type?: string;
  content_ids?: string[];
  content_category?: string;
  value?: number;
  currency?: string;
  num_items?: number;
}

type FbqFn = (...args: unknown[]) => void;

const getFbq = (): FbqFn | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return (window as unknown as { fbq?: FbqFn }).fbq ?? null;
};

/**
 * Fires a Meta Pixel standard event to ALL initialized pixels (base + event-specific).
 * Only fires in production; logs in dev for debugging.
 */
const trackPixelEvent = (eventName: string, params?: PixelEventParams): void => {
  if (!config.production) {
    console.log(`[MetaPixel] (dev) ${eventName}`, params);
    return;
  }

  const fbq = getFbq();
  if (!fbq) {
    console.warn(`[MetaPixel] fbq not available, skipping ${eventName}`);
    return;
  }

  try {
    fbq('track', eventName, { ...params, currency: params?.currency || 'ARS' });
  } catch (error) {
    console.error(`[MetaPixel] Error tracking ${eventName}:`, error);
  }
};

export const trackViewContent = (params: PixelEventParams): void => {
  trackPixelEvent('ViewContent', params);
};

export const trackAddToCart = (params: PixelEventParams): void => {
  trackPixelEvent('AddToCart', params);
};

export const trackInitiateCheckout = (params: PixelEventParams): void => {
  trackPixelEvent('InitiateCheckout', params);
};

export const trackAddPaymentInfo = (params: PixelEventParams): void => {
  trackPixelEvent('AddPaymentInfo', params);
};

export const trackPurchase = (params: PixelEventParams): void => {
  trackPixelEvent('Purchase', params);
};
